import { LeakTestCertificate } from "../types/LeakTestCertificate";
import { PartOrderWithImages } from "../types/PartOrderWithImages";


export const getUniqueFileName = (partOrder: PartOrderWithImages): string => {
  let imageName: string = partOrder.weldId;
  let i = 0;
  console.log(JSON.stringify(partOrder));
  while(partOrder.images.includes(`images${partOrder.weldId}\\${imageName}.png`)) {
    ++i; 
    imageName = `${partOrder.weldId} (${i})`
  }
  return imageName;
}

export function getUniquePartProductionOrderNumber(
  partProductionOrderNumber: string,
  partProductionOrderNumbers: string[]
): [string, number] {
  let i = 0;
  const partProduction = partProductionOrderNumber.split(' ')[0];
  let candidate = partProductionOrderNumber;

  while (partProductionOrderNumbers.includes(candidate)) {
    ++i;
    candidate = `${partProduction} (${i})`;
  }

  return [candidate, partProductionOrderNumbers.indexOf(partProduction) + i];
}

